import { CellViewBase } from '../base';
import { Component } from '@angular/core';

@Component({
    selector: 'fi-checklist-report-view-checkpoints-per-unit-table-cell-view-text',
    template: '<a href class="no-decorate" (click)="tableCellClick($event)">{{data[column.prop]}}</a>',
    standalone: false,
})
export class TextComponent extends CellViewBase {}
